import { render, staticRenderFns } from "./Latestbroadcast.vue?vue&type=template&id=44dc016a"
import script from "./Latestbroadcast.vue?vue&type=script&lang=js"
export * from "./Latestbroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports